import {gql} from '@apollo/client';

import {QueryResultType, useSkippableBenchlingQuery} from 'graphql-client/BenchlingQuery';

import {
  CreateEntitiesEntitySchemasQuery,
  CreateEntitiesEntitySchemasQuery_tagSchemas_TagSchemaNode as CreateEntitiesEntitySchema,
} from './__generated/CreateEntitiesEntitySchemasQuery';

export type CreateEntitiesEntitySchemaGraphQL = CreateEntitiesEntitySchema;

export const CREATE_ENTITIES_ENTITY_SCHEMAS_QUERY = gql`
  query CreateEntitiesEntitySchemasQuery @skipAudit @engComponent(name: REGISTRY) {
    tagSchemas {
      id
      name
      fieldsJson
      labelingStrategies
    }
  }
`;

export function useCreateEntitiesEntitySchemas(
  skip?: boolean
): Array<CreateEntitiesEntitySchemaGraphQL> | null {
  const result = useSkippableBenchlingQuery<CreateEntitiesEntitySchemasQuery>(
    CREATE_ENTITIES_ENTITY_SCHEMAS_QUERY,
    {skip: Boolean(skip)}
  );

  if (result.type !== QueryResultType.SUCCESS) {
    return null;
  }
  return result.data.tagSchemas;
}
